import React, { useState } from "react";

const AddLink = (props) => {
  // const [linkName, setLinkName] = useState([]);
  // const [linkUrl, setLinkUrl] = useState([]);

  // const linkNameChangeHandler = (e) => {
  //   setLinkName({ ...linkName, [e.target.name]: e.target.value });
  // };
  // const urlChangeHandler = (e) => {
  //   setLinkUrl({ ...linkUrl, [e.target.name]: e.target.value });
  // };

  // console.log("linkName", linkName);
  // console.log("linkUrl", linkUrl);

  return (
    <React.Fragment>
      <div className="col-xl-6  col-md-6 mb-4">
        <label className="form-label font-w600">Link name</label>
        <div className="input-group">
          <input
            type="text"
            className="form-control solid"
            name="title"
            placeholder="title"
            aria-label="title"
            onChange={(e) => props.onAddLinkHandler(e, props.index)}
            defaultValue={props.val.title}
          />
        </div>
      </div>
      <div className="col-xl-6  col-md-6 mb-4">
        <label className="form-label font-w600">URL</label>
        <div className="input-group">
          <input
            type="text"
            className="form-control solid"
            name="link"
            placeholder="URL (https://instagram.com/yourname)"
            aria-label="link"
            onChange={(e) => props.onAddLinkHandler(e, props.index)}
            defaultValue={props.val.link}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddLink;
